import ContentCard from 'components/common/general/layouts/ContentCard';
import styled from 'styled-components';

export const ToggleWrapperStyled = styled.div`
  margin: 0 auto 7rem;
`;

export const ListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const WrapperStyled = styled(ContentCard)`
  padding: 4rem 4rem 8rem;
`;
